@import '../../global/min-app.css';


:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}


.article-container {
  @apply md:pr-32px w-full;
}

.text-yellow {
  color: #f4cc48;
}

.text-orange {
  color: #e16838;
}

.text-light-blue {
  color: #5cbbe5;
}

.text-medium-blue {
  color: #117cb8;
}

.text-dark-blue {
  color: #193556;
}

.text-red {
  color: #d74634;
}

.text-maroon {
  color: #662456;
}

.text-dark-green {
  color: #00855d;
}

.text-light-green {
  color: #d2de87;
}

.text-ui-gray-1 {
  color: #3E3E3E;
}

.text-ui-gray-2 {
  color: #5E5E5E;
}

.text-ui-gray-3 {
  color: #7E7E7E;
}

.text-ui-gray-4 {
  color: #AEAEAE;
}

.text-ui-gray-5 {
  color: #DEDEDE;
}

.text-ui-gray-6 {
  color: #EEEEEE;
}
